import { equals } from "./fable_modules/fable-library-js.4.19.0/Util.js";
import { Page } from "./WebParts/User/Home/Types.fs.js";
import { Page as Page_1 } from "./WebParts/User/QuickFinder/Types.fs.js";
import { HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { defaultArg, defaultArgWith } from "./fable_modules/fable-library-js.4.19.0/Option.js";
import { AllParts } from "./WebParts/WebPartRegistry.fs.js";
import { PageHeader, Msg } from "../Bfs.Web.Portale/Types.fs.js";
import { pageNotFound } from "../Bfs.Web.Portale/Render.fs.js";
import { userMenu, topMenu, mainMenuMobile, mainMenu as mainMenu_1 } from "./Kundenportal.MenuDef.fs.js";
import { Roles_IsSomeAdmin } from "../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { empty } from "./fable_modules/fable-library-js.4.19.0/List.js";
import { Model } from "./WebParts/Login/Types.fs.js";
import { Model as Model_1 } from "./WebParts/Password/Types.fs.js";
import { NotificationTriggerProps, View } from "./Notifications/Trigger.fs.js";
import { ListProps, View as View_1 } from "./Notifications/List.fs.js";
import { ContextProviderProps, View as View_2 } from "./Notifications/ContextProvider.fs.js";
import { main, Menu_NotificationMenu } from "../Bfs.Web.Portale/Template.fs.js";
import { BannerModel, Banner } from "./PWA/Pwa.fs.js";
import { Page as Page_2 } from "./WebParts/StaticPages/Types.fs.js";
import { currentPageContext } from "./Context.fs.js";

function bigCoverPicture(model, dispatch) {
    let children_4, children, props, children_2, props_4;
    if ((model.User != null) && (equals(model.Page, new Page()) ? true : equals(model.Page, new Page_1(0, [""])))) {
        return (children_4 = [(children = [(props = [new HTMLAttr(149, ["CoverHomepageSmall.webp"]), ["style", {
            width: "100%",
        }]], react.createElement("img", keyValueList(props, 1)))], react.createElement("div", {
            className: "is-hidden-tablet",
        }, ...children)), (children_2 = [(props_4 = [new HTMLAttr(149, ["CoverHomepage.webp"]), ["style", {
            width: "100%",
        }]], react.createElement("img", keyValueList(props_4, 1)))], react.createElement("div", {
            className: "is-hidden-mobile",
        }, ...children_2))], react.createElement("div", {
            className: "bigcover",
        }, ...children_4));
    }
    else {
        return undefined;
    }
}

function renderPage(model, dispatch) {
    return defaultArgWith(AllParts.TryView(model, dispatch, (page) => {
        dispatch(new Msg(3, [page]));
    }), () => pageNotFound);
}

export function view(model, dispatch) {
    let MobileTrigger, MobileDropdown;
    let patternInput;
    const matchValue = model.User;
    if (matchValue != null) {
        const user = matchValue;
        patternInput = [mainMenu_1(user), mainMenuMobile(user), Roles_IsSomeAdmin(user.Roles) ? "fas fa-user-secret" : "fas fa-user-circle", !Roles_IsSomeAdmin(user.Roles)];
    }
    else {
        patternInput = [empty(), empty(), "", false];
    }
    const backgroundClass = ((model.PageModel instanceof Model) ? true : (model.PageModel instanceof Model_1)) ? "loginbg app-wrapper" : "app-wrapper";
    const header = defaultArg(AllParts.TryGetHeader(model), new PageHeader(1, ["BFS-Kundenportal"]));
    const notifications = patternInput[3] ? ((MobileTrigger = View(new NotificationTriggerProps(false)), (MobileDropdown = View_1(new ListProps(false)), new Menu_NotificationMenu((children) => View_2(new ContextProviderProps(dispatch, children)), View(new NotificationTriggerProps(true)), MobileTrigger, MobileDropdown)))) : undefined;
    const children_1 = [Banner(new BannerModel(model, dispatch)), main(dispatch, model, header, bigCoverPicture(model, dispatch), patternInput[2], topMenu, userMenu(dispatch), patternInput[0], patternInput[1], notifications, new Page_2(1, []), new Page_2(0, []), backgroundClass, renderPage(model, dispatch))];
    return react.createElement(currentPageContext.Provider, {
        value: model.Page,
    }, ...children_1);
}

//# sourceMappingURL=Kundenportal.View.fs.js.map
